import React, { useEffect, useState} from 'react';
import { Loading } from '../../components/Loading';
import TextTool from './TextTool';
import ClipArtTool from './ClipArtTool';
import BackgroundTool from './BackgroundTool';
import DrawingTool from './DrawingTool';
import ShapeTool from './ShapeTool';

const ToolBox = ({canvas=null, className="left"})=>{
    const [activeTab, setActiveTab] = useState('clipart');

    useEffect(() => {
        if( null===canvas ) return;
        canvas.on('selection:created', onSelectionUpdated);
        canvas.on('selection:updated', onSelectionUpdated);

        return ()=>{
            canvas.off('selection:created', onSelectionUpdated);
            canvas.off('selection:updated', onSelectionUpdated);
        }
    }, [canvas]);
    
    function onSelectionUpdated(event){
        // 5.0은 이렇게 쓰네 
        const selecttedItem = event.selected[0];
        if(selecttedItem.isType('textbox')){
            setActiveTab('textbox');
        }
    }

    function onChangeTab(tabName){
        canvas.isDrawingMode = false;
        setActiveTab(tabName);
    }
    
    
    if( null===canvas)return <Loading />
    
    return(
        <div className="toolbox">
            <div className="pannel tab_area">
                <ul className="tab_menu col5">
                    <li className={activeTab === 'background'?'on':''}><a href="#tab01" onClick={(e) => { onChangeTab('background');e.preventDefault(); }} >배경</a></li>
                    <li className={activeTab === 'clipart'?'on':''}><a href="#tab02" onClick={(e) => { onChangeTab('clipart');e.preventDefault(); }} >그림</a></li>
                    <li className={activeTab === 'textbox'?'on':''}><a href="#tab03" onClick={(e) => { onChangeTab('textbox');e.preventDefault(); }} >글자</a></li>
                    <li className={activeTab === 'line'?'on':''}><a href="#tab04" onClick={(e) => { onChangeTab('line');e.preventDefault(); }} >펜</a></li>
                    <li className={activeTab === 'shape'?'on':''}><a href="#tab05" onClick={(e) => { onChangeTab('shape');e.preventDefault(); }} >도형</a></li>
                </ul>
                <div className="tab_cont">
                    { activeTab==='background' &&  <BackgroundTool canvas={canvas} />  }
                    { activeTab==='clipart' && <ClipArtTool canvas={canvas} /> }
                    { activeTab==='textbox' && <TextTool canvas={canvas} /> }
                    { activeTab==='line' && <DrawingTool canvas={canvas} /> }
                    { activeTab==='shape' && <ShapeTool canvas={canvas} /> }
                </div>
            </div>
        </div>
    );
}
export default ToolBox;